import { render, staticRenderFns } from "./WhatsAppReminderTemplateNote.vue?vue&type=template&id=02c9d482&scoped=true"
import script from "./WhatsAppReminderTemplateNote.vue?vue&type=script&lang=js"
export * from "./WhatsAppReminderTemplateNote.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppReminderTemplateNote.vue?vue&type=style&index=0&id=02c9d482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c9d482",
  null
  
)

export default component.exports